import { TypedAnalyticsEvent } from "@omni/types/components/tracking/analyticsEvent";
import { EventType } from "@omni/types/components/tracking/eventType.enum";
import { ProductImpressionTrackingInfo } from "@omni/types/components/tracking/tracking-info/impression/productImpression.trackingInfo";

import { getPageInfo, getUserInfo } from "@/services/tracking/trackers/utils";
import * as TrackingService from "@/services/tracking/tracking.service";

export const track = (trackingInfo: ProductImpressionTrackingInfo) => {
    const event: TypedAnalyticsEvent<ProductImpressionTrackingInfo> = {
        event: EventType.ProductDetailImpression,
        payload: {
            eventData: trackingInfo,
            pageInfo: getPageInfo(),
            userInfo: getUserInfo()
        }
    };

    TrackingService.track(event);
};
